/**
 * StagingBanner
 *
 * A fixed top banner shown only in the staging environment so it is never
 * mistaken for production. Gated on the build-time VITE_APP_ENV value, which
 * is set to "staging" for the Vercel `staging` custom environment.
 */

import React from 'react';

export default function StagingBanner() {
  if (import.meta.env.VITE_APP_ENV !== 'staging') return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-purple-600/95 backdrop-blur-sm text-white text-xs font-semibold tracking-wide py-1.5 px-4 flex items-center justify-center gap-2">
      <span aria-hidden="true">⚠️</span>
      <span>STAGING ENVIRONMENT — not production data</span>
    </div>
  );
}
